module.exports = __webpack_public_path__ + "assets/images/animations/fundivisa-animation.webp?c02f096d";